import './styles.css';
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell, faCashRegister, faList, faPlus, faReceipt, faRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import {logout} from "../../pages/Login/functions";

const SideBar = ({collapsed}) => {

    return (
        <nav id="sidebar" className={`sidebar js-sidebar ${collapsed ? "collapsed" : ""}`}>
            <div className="sidebar-content js-simplebar">
                <a className="sidebar-brand" href="index.html">
                    <span className="align-middle">AdminKit</span>
                </a>

                <ul className="sidebar-nav pb-5">

                    <li className="sidebar-header">
                        پیج
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./pages"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./pages/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        دسته بندی محصولات
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./productCategories"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./productCategories/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        واحد های پول
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./currencies"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./currencies/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        برند
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./brands"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./brands/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        سفارشات
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./orders"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./orders/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">ایجاد فاکتور</span>
                        </Link>
                    </li>


                    <li className="sidebar-header">
                        محصولات
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./products"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./products/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./products/requests"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faBell}/>
                            <span className="align-middle">درخواست ها</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        کامنت ها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./comments"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>


                    <li className="sidebar-header">
                        مدیران اپلیکیشن
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./managers"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./managers/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        مدیریت انبارداران
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./storagemen"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./storagemen/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        مدیریت راننده ها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./drivers"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./drivers/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        مدیریت مشتری ها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./customers"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./customers/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>


                    <li className="sidebar-header">
                        مدیریت اطلاعات حساب ها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./credit-cards"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./credit-cards/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        کد های تخفیف
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./discount-codes"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./discount-codes/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        تراکنش های مالی
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./transactions"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./receipts"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faReceipt}/>
                            <span className="align-middle">رسید های واریز</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./installments"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faCashRegister} />
                            <span className="align-middle">اقساط مشتریان</span>
                        </Link>
                    </li>




                    <li className="sidebar-item">
                        <Link to={"./transactions/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>


                    <li className="sidebar-item mt-4">
                        <Link className={"sidebar-link"} onClick={() => {
                            logout();
                            window.location.reload();
                        }}>
                            <FontAwesomeIcon className={'ms-2'} icon={faRightFromBracket}/>
                            <span className="align-middle">خروج</span>
                        </Link>
                    </li>


                </ul>

            </div>
        </nav>
    );
};

export default SideBar;